module.exports = __webpack_public_path__ + "img/img-1.6108dcf1.png";